module.exports = __webpack_public_path__ + "img/编组 15@2x.f8f01830.png";